{
  "$comment": "THE register of every legal document (docs/legal/index.html is rendered from it). One row per document (`label` is an optional shorter link text for a footer, where the surface already says who the document is for): who it is for, its version, its master file, where it is published and how it is accepted. A surface links only the documents listed for it, and only documents of its own audience or of everyone (legal.test.ts). Changing a document is: edit its master, bump its version here.",
  "documents": [
    {
      "id": "guest-terms",
      "audience": "guest",
      "title": { "fr": "Conditions générales", "en": "Terms and conditions" },
      "version": "2026-10-05",
      "master": {
        "fr": "apps/guest-web/src/legal/terms.fr.html",
        "en": "apps/guest-web/src/legal/terms.en.html"
      },
      "host": "order",
      "path": { "fr": "/legal/conditions", "en": "/legal/terms" },
      "acceptance": "checkout"
    },
    {
      "id": "guest-how-it-works",
      "audience": "guest",
      "title": { "fr": "Comment fonctionne Croissant in Bed", "en": "How Croissant in Bed works" },
      "version": "2026-10-05",
      "master": {
        "fr": "apps/guest-web/src/legal/how-it-works.fr.html",
        "en": "apps/guest-web/src/legal/how-it-works.en.html"
      },
      "host": "order",
      "path": { "fr": "/legal/fonctionnement", "en": "/legal/how-it-works" },
      "acceptance": "none"
    },
    {
      "id": "partner-terms",
      "audience": "partner",
      "title": { "fr": "Conditions générales de partenariat", "en": "Partnership terms" },
      "label": { "fr": "Conditions générales", "en": "Terms" },
      "version": "1.2",
      "master": { "fr": "docs/legal/partenaires/Conditions_generales_partenariat.docx" },
      "host": "www",
      "path": { "fr": "/legal/conditions-generales" },
      "acceptance": "partner-sign-up"
    },
    {
      "id": "conciergerie-contract",
      "audience": "partner",
      "title": { "fr": "Contrat de partenariat — Conciergerie" },
      "version": "1.2",
      "master": { "fr": "docs/legal/partenaires/Contrat_partenariat_Conciergerie.docx" },
      "host": null,
      "path": null,
      "acceptance": "signature"
    },
    {
      "id": "bakery-contract",
      "audience": "bakery",
      "title": { "fr": "Contrat de boulangerie partenaire" },
      "version": "0.4",
      "master": { "fr": "docs/legal/boulangeries/Contrat_partenariat_Boulangerie.docx" },
      "host": null,
      "path": null,
      "acceptance": "signature"
    },
    {
      "id": "legal-notice",
      "audience": "everyone",
      "title": { "fr": "Mentions légales", "en": "Legal notice" },
      "version": "2026-10-05",
      "master": { "fr": "website/tools/build-pages.py", "en": "website/tools/build-pages.py" },
      "host": "www",
      "path": { "fr": "/legal/mentions-legales", "en": "/en/legal/legal-notice" },
      "acceptance": "none"
    },
    {
      "id": "privacy",
      "audience": "everyone",
      "title": { "fr": "Politique de confidentialité", "en": "Privacy policy" },
      "version": "2026-10-09",
      "master": { "fr": "website/tools/build-pages.py", "en": "website/tools/build-pages.py" },
      "host": "www",
      "path": { "fr": "/legal/confidentialite", "en": "/en/legal/privacy" },
      "acceptance": "none"
    },
    {
      "id": "cookies",
      "audience": "everyone",
      "title": { "fr": "Politique de cookies", "en": "Cookie policy" },
      "version": "2026-08-19",
      "master": { "fr": "website/tools/build-pages.py", "en": "website/tools/build-pages.py" },
      "host": "www",
      "path": { "fr": "/legal/cookies", "en": "/en/legal/cookies" },
      "acceptance": "none"
    }
  ],
  "surfaces": {
    "order": {
      "audience": "guest",
      "documents": ["guest-terms", "guest-how-it-works", "privacy", "legal-notice"]
    },
    "www": {
      "audience": "partner",
      "documents": ["partner-terms", "legal-notice", "privacy", "cookies"]
    },
    "app": { "audience": "partner", "documents": ["partner-terms", "privacy"] }
  }
}
